<template>
  <div>
    <p v-text-lbl="'deadline'" class="endTime" :endTime="dellTime(voCopy.endTime)"> 截止时间： {{ dellTime(voCopy.endTime) }}</p>
    <template v-if="voCopy.passenger">
      <ul v-for="(item, index) in voCopy.passenger['subjects']" :key="index" class="voteInfo">
        <li class="title">{{ item.subject }} ({{ voteTypeArr[item.voteType-1] }})</li>
        <li v-for="(choice, _index) in item.passenger['choices']" :key="_index" class="choices">
          <!-- {{ choice }} -->
          <!-- <div class="fr" style="z-index:2">
            <span>{{ choice.voteNum }}票</span>
            <span v-if="totleVoteNum!=0">&nbsp;{{ choice.votePercent }}%</span>
          </div>
          <div :id="choice.id" class="tpprocess" /> -->
          <div class="progress-box">
            <div v-text-lbl="'item'" :num="_index + 1">选项 :{{ choice.subject }}</div>
            <div><el-progress :percentage="choice.votePercent" /></div>
          </div>
          <div class="num"><span v-text-lbl="'voto'" :num="choice.voteNum"> {{ choice.voteNum }}票 </span></div>
        </li>
        <li class="all-box">
          <span v-text-lbl="'total'" class="fl"> 合计 </span>
          <span v-text-lbl="'voto'" class="fr" :num="item.voteNum"> {{ item.voteNum }}票 </span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {
    },
    props: {
        id: { type: String, default: function() { return '' } },
        type: { type: String, default: function() { return '' } },
        row: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'voteManage',
            voCopy: {},
            voteTypeArr: [this.$tx('hygl.voteManage.Radio', '单选'), this.$tx('hygl.voteManage.multipleChoice', '多选')],
            totleVoteNum: '',
            tpList: [],
            curUserChoiceList: [],
            exportData: []
        }
    },
    computed: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
        this.getVote()
    },
    methods: {
        /**
         * 获取投票主题信息
         */
        checkVote(resultId, orgCode, voteId, voteName) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: [
                    {
                        'compare': '=',
                        'field': 'resultId',
                        'merge': true,
                        'value': resultId
                    }
                ],
                url: 'hygl/voteResultInfo/querydata'
            }).then(res => {
                if (res.code === 'success') {
                    this.curUserChoiceList = res.body.listdata
                    console.log(this.curUserChoiceList)
                    // 遍历用户投票的选项
                    this.curUserChoiceList.forEach((item, i) => {
                        $('#' + item.choiceId).css('background', '#FFB693')
                    })
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        getVote() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    id: this.id
                },
                url: 'hygl/vote/getById'
            }).then(res => {
                if (res.code === 'success') {
                    if (this.type === 'statistics') {
                        this.checkVote(this.row.id, this.row.orgCode, this.row.voteId, this.row.voteName)
                    } else {
                        this.voCopy = res.body.vo
                        this.voteStat()
                        this.queryStat()
                    }
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 查询主题投票人数
         */
        voteStat() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    themeId: this.id
                },
                url: 'hygl/vote/queryThemeVoters'
            }).then(res => {
                if (res.code === 'success') {
                    this.totleVoteNum = res.body.voters
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 查询选项投票统计
         */
        queryStat() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    themeId: this.id
                },
                url: 'hygl/voteResult/querydataByTheme'
            }).then(res => {
                if (res.code === 'success') {
                    this.tpList = res.body.listdata
                    this.voCopy.passenger['subjects'].forEach((item, i) => {
                        item.voteNum = 0
                        item.passenger['choices'].forEach((choice, i) => {
                            choice.voteNum = this.tpList[item.subject][choice.subject]
                            // 计算每道题目总的票数
                            item.voteNum += choice.voteNum
                        })
                    })
                    setTimeout(() => {
                        this.voCopy.passenger['subjects'].forEach((item, i) => {
                            item.passenger['choices'].forEach((choice, j) => {
                                // 保证所有百分比加起来为1
                                if (j === item.passenger['choices'].length - 1) {
                                    this.getPer(j, item)
                                } else {
                                    if (choice.voteNum > 0) {
                                        choice.votePercent = Math.round(choice.voteNum / item.voteNum * 100)
                                    } else {
                                        choice.votePercent = 0
                                    }
                                }
                                $('#' + choice.id + '.tpprocess').width(choice.votePercent + '%')
                            })
                        })
                        this.$forceUpdate()
                        this.exportDataFmt(this.voCopy.passenger['subjects'])
                    }, 0)
                    this.$forceUpdate()
                }
            })
        },
        /**
         * 递归计算最后一个选项的百分比，保证所有选项百分比之和为1
         */
        getPer(m, item) {
            if (item.passenger['choices'][m]['voteNum'] > 0) {
                var temp = 100
                for (var k = 0; k < m; k++) {
                    temp -= item.passenger['choices'][k]['votePercent']
                }
                item.passenger['choices'][m]['votePercent'] = temp
            } else {
                item.passenger['choices'][m]['votePercent'] = 0
                if (m > 0) {
                    this.getPer(m - 1, item)
                }
            }
        },
        exportDataFmt(data) {
            console.log('data===>', data)
            data.forEach((item, index) => {
                item.voteNum = 0
                this.exportData.push(item.subject + '(' + this.voteTypeArr[item.voteType - 1] + ')')
                item.passenger['choices'].forEach((choice, _index) => {
                    this.exportData.push('选项：' + choice.subject + ' 结果：' + choice.voteNum + '票' + ' ' + choice.votePercent + '%')
                    item.voteNum += choice.voteNum
                })
                this.exportData.push('合计：' + item.voteNum)
            })
            this.$emit('exportDataFmt', this.exportData)
        },
        dellTime(time) {
            return moment(new Date(time)).format('YYYY-MM-DD HH:mm')
        }
    }
}
</script>

<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
.endTime {
  margin: 0;
  line-height: 40px;
  font-size: 1.1em;
}
.voteInfo {
  border: 1px solid #E0E0E0;
  border-bottom: none;
  margin: 0 0 20px;
  li {
    border-bottom: 1px solid #E0E0E0;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    position: relative;
    .tpprocess {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: #C4E0FF;
        z-index: 1;
    }
  }
  .choices {
    display: flex;
    padding-left: 20px!important;
    padding-right: 20px!important;
  }
}
.title{
    font-size: var(--portalFontSize14);
    font-weight: bold;
    color: #333;
}
.progress-box{
    padding-bottom: 19px;
    width: calc(100% - 50px);
}
.num{
    position: relative;
    width: 50px;
    span{
        width: 50px;
        position: absolute;
        bottom: 19px;
        line-height: 1;
        text-align: center;
    }
}
.fr{
    width: 50px;
    text-align: center;
}
.all-box{
    padding-left: 20px!important;
    padding-right: 20px!important;
}
</style>
